import { render, staticRenderFns } from "./transacPassword.vue?vue&type=template&id=58451f94&scoped=true&"
import script from "./transacPassword.vue?vue&type=script&lang=js&"
export * from "./transacPassword.vue?vue&type=script&lang=js&"
import style0 from "./transacPassword.vue?vue&type=style&index=0&id=58451f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58451f94",
  null
  
)

export default component.exports